import React from "react"
import styled, { css } from "styled-components"

const size = {
  tablet: 950,
  mobile: 600,
}
const below = Object.keys(size).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${size[label]}px) {
      ${css(...args)};
    }
  `
  return acc
}, {})

const above = Object.keys(size).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (min-width: ${size[label]}px) {
      ${css(...args)};
    }
  `
  return acc
}, {})

const ArticleWrapper = styled.div`
  p {
    font-size: 20px;
    line-height: 32px;
    color: var(--alt-black);
    margin-bottom: 40px;

    strong {
      font-weight: 600;
    }
    :last-child {
      margin-bottom: 0;
    }
  }

  h2 {
    font-weight: 600;
    font-size: 36px;
    line-height: 44px;
    margin: 56px 0 16px;
    color: var(--alt-black);

    ${above.mobile`
    font-size:44px;
    line-height:60px;
    margin:56px 0 20px;
    `}
  }
  h3 {
    font-weight: 600;
    font-size: 28px;
    line-height: 36px;
    color: var(--alt-black);
    margin: 40px 0 12px;
    ${above.mobile`
    font-size:36px;
    line-height:44px;
    margin:48px 0 16px;
    `}
  }

  h4 {
    font-weight: 600;
    font-size: 22px;
    line-height: 36px;
    color: var(--alt-black);
    margin: 32px 0 8px;
    ${above.mobile`
    font-size:28px;
    margin:40px 0 12px;
    
    `}
  }

  h5 {
    font-weight: 600;
    font-size: 20px;
    line-height: 32px;
    color: var(--alt-black);
    margin: 24px 0 4px;
    ${above.mobile`
    font-size:22px;
    line-height:28px;
    margin:32px 0 8px;
    `}
  }
  a {
    color: #4082c4;
  }

  ul {
    margin-bottom: 32px;
  }
  li {
    font-size: 24px;
    line-height: 32px;
    :before {
      position: absolute;
      top: 16px;
      left: 6px;
      content: "";
      background-color: black;
      width: 6px;
      height: 6px;
      border-radius: 50%;
    }
  }
  blockquote {
    margin: 40px 0;
    padding: 0;
    p {
      font-size: 32px;
      line-height: 40px;
      color: #4082c4;
      font-style: italic;
      ${below.mobile`
      font-size: 28px;
      line-height: 32px;
      `}
    }
  }
`

const ArticleBody = props => {
  return (
    <ArticleWrapper
      dangerouslySetInnerHTML={{
        __html: props.content.html,
      }}
    />
  )
}

export default ArticleBody
